// extracted by mini-css-extract-plugin
module.exports = {"no-asset-view__icon":"style_no-asset-view__icon__Sz0WY"};